import React from 'react';
import styled from 'styled-components';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

export interface Props {
  onDelete?: () => void;
  onEdit?: () => void;
  hideDeleteButton?: boolean;
  hideEditButton?: boolean;
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 5%;
`;

const Button = styled.button`
  font-size: 100%;
  border: 0;
  padding: 0;
  background-color: transparent;
  margin-right: 4px;
`;

const ListModifier: React.FC<Props> = ({ onEdit, onDelete, hideEditButton, hideDeleteButton }) => {
  return (
    <Container>
      {!hideEditButton && (
        <Button onClick={onEdit}>
          <EditOutlined style={{ color: '#00ACD0', fontSize: '20px', marginRight: '2px' }} />
        </Button>
      )}
      {!hideDeleteButton && (
        <Button onClick={onDelete}>
          <DeleteOutlined style={{ color: 'red', fontSize: '20px', marginLeft: '10px' }} />
        </Button>
      )}
    </Container>
  );
};

export default ListModifier;
